import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransactionStats, TxListRequest, TxRecheckRequest } from '@/api';
import { Numeric } from '@/models';
import { ComplianceTransferData, ComplianceTransferList } from '../models';

export interface ComplianceTransferSliceState {
  data: ComplianceTransferData;
  loading: boolean;
  error: string | null;
}

const initialState: ComplianceTransferSliceState = {
  data: null,
  loading: false,
  error: null,
};

const complianceTransferSlice = createSlice({
  name: 'complianceTransfers',
  initialState,
  reducers: {
    setStats: (state, action: PayloadAction<TransactionStats>) => {
      return {
        ...state,
        data: {
          transfers: { ...(state.data?.transfers || { txs: [], total: 0 }) },
          stats: action.payload,
        },
      };
    },
    setList: (state, action: PayloadAction<ComplianceTransferList>) => {
      return {
        ...state,
        data: {
          transfers: { ...action.payload },
          stats: { ...(state.data?.stats || ({} as TransactionStats)) },
        },
      };
    },
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    fetchTransferStats: (state) => ({
      ...state,
      error: null,
      loading: true,
    }),
    fetchTransfers: (state, action: PayloadAction<TxListRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    txRecheck: (state, action: PayloadAction<TxRecheckRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    applyDefault: (state) => ({
      ...state,
      error: null,
      loading: true,
    }),
  },
});

export { complianceTransferSlice };
